/**
 * Session memory for the purchase funnel, so the site never sells the same
 * thing twice: once a ladder has been shown this session it does not reopen,
 * and every event carries where the customer's selection came from.
 */

export type SelectionSource =
  | 'single_standard'
  | 'single_lifetime'
  | 'single_lifetime_free_shipping_rescue'
  | 'single_lifetime_private_rescue'
  | 'two_unit_selection'
  | 'free_third_claimed'
  | 'direct_three_pack'
  | 'manual_quantity_three'
  | 'three_pack_expansion'
  | 'direct_six_pack'
  | 'manual_quantity_six'
  | 'six_pack_expansion'
  | 'direct_thirty_pack'
  | 'manual_quantity_thirty'
  | 'business_expansion'

export type FlowKind =
  | 'single-no-lifetime'
  | 'single-lifetime-shipping'
  | 'two-systems'
  | 'trio-expansion'
  | 'six-expansion'
  | 'business-expansion'

const SEEN_PREFIX = 'gritvue-flow-seen:'
const SOURCE_KEY = 'gritvue-selection-source'

function storage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage
  } catch {
    return null
  }
}

export function flowSeen(kind: FlowKind): boolean {
  return storage()?.getItem(SEEN_PREFIX + kind) === '1'
}

export function markFlowSeen(kind: FlowKind) {
  storage()?.setItem(SEEN_PREFIX + kind, '1')
}

export function setSelectionSource(source: SelectionSource) {
  storage()?.setItem(SOURCE_KEY, source)
}

export function getSelectionSource(): SelectionSource | null {
  return (storage()?.getItem(SOURCE_KEY) as SelectionSource | null) ?? null
}
